import {Presentation, PresentationState} from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {WGParsedGameData} from "../../server/data/WGParsedGameData";
import {WGEngineManager} from "../../engine/WGEngineManager";

export class ReelStoppedPresentation extends Presentation {

    public checkForActivation(data: WGParsedGameData): boolean {
        return data.nearWinReels.indexOf(true) >= 0 && (data.nextMode != GameMode.NORMAL || data.warriorPayout >= 0 || data.singleWin >= 0);
    }

    public getPresentation(): void {
        WGEngineManager.RSWindow((r: number, s: number) => {
            WGEngineManager.getReel(r)!.getSymbol(s)!.attentionDarkness(0, 0.25);
        });
        this.pTimeline.to(this, 0.25, {});
        this.PresentationState.set(PresentationState.INACTIVE);
    }
}

